import React, { useEffect, useState } from 'react';
import IconButton from '@material-ui/core/IconButton';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { useStyles } from './styles';
import i18n from 'i18n-js';
import { Tabs, Tab } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import RestaurantStockTab from './components/RestaurantStockTab';
import AllRestaurantsStockTab from './components/AllRestaurantsStockTab';
import { useAppSelector } from 'index';
import { NothingToSee, SkeletonBlock, TableSkeleton } from 'components/shared';
import { useFirstLoad } from 'hooks/useFirstLoad';

enum StockTabs {
    CurrentRestaurant,
    AllRestaurants,
}

export default function StockPage() {
    const classes = useStyles();
    const history = useHistory();
    const [tabActive, setTab] = useState<StockTabs>(StockTabs.CurrentRestaurant);
    const currentRestaurant = useAppSelector(
        (state) => state.restaurantDetails.restaurantInformation
    );
    const isCoolBox = currentRestaurant?.coolBoxData?.isCoolBox;
    const isInformationSettled = useAppSelector(
        (state) => state.restaurantDetails.isRestaurantInformationSettled
    );
    const [isCurrentTabLoading, settleCurrentTab] = useFirstLoad();
    const [isAllTabLoading, settleAllTab] = useFirstLoad();

    function handleChangeTab(event: React.ChangeEvent<{}>, view: number) {
        setTab(view);
    }

    useEffect(() => {
        if (currentRestaurant.id && !isCoolBox) {
            history.replace('/orders');
        }
    }, [currentRestaurant.id]);

    if (isInformationSettled && !isCoolBox) {
        return <NothingToSee />;
    }

    return (
        <>
            <div className={classes.headerContainer}>
                <IconButton
                    aria-label="delete"
                    size="small"
                    color="primary"
                    className={classes.iconButton}
                    onClick={() => history.goBack()}
                >
                    <ArrowBackIcon fontSize="inherit" />
                </IconButton>
                <Tabs
                    value={tabActive}
                    onChange={handleChangeTab}
                    aria-label="wrapped label tabs example"
                    indicatorColor="primary"
                    textColor="primary"
                >
                    <Tab
                        value={StockTabs.CurrentRestaurant}
                        label={i18n.t('navigationTabs.currentRestaurant')}
                    />
                    <Tab
                        value={StockTabs.AllRestaurants}
                        label={i18n.t('navigationTabs.allRestaurants')}
                    />
                </Tabs>
            </div>
            {isInformationSettled && tabActive === StockTabs.CurrentRestaurant && (
                <RestaurantStockTab onLoaded={settleCurrentTab} />
            )}
            {isInformationSettled && tabActive === StockTabs.AllRestaurants && (
                <AllRestaurantsStockTab onLoaded={settleAllTab} />
            )}
            <TableSkeleton
                key={tabActive}
                isLoading={
                    !isInformationSettled ||
                    (tabActive === StockTabs.CurrentRestaurant
                        ? isCurrentTabLoading
                        : isAllTabLoading)
                }
                columnWidths={[40, undefined, undefined, 120, 120, 120]}
                style={{ top: 49 }}
            >
                <SkeletonBlock height={36} width={360} />
                <SkeletonBlock height={36} width={200} style={{ marginLeft: 'auto' }} />
            </TableSkeleton>
        </>
    );
}
